export const defaultBorrowerLegalName = 'the Business';
